import { TaskId } from '/imports/domain';
import { QuestionId, QuizAttemptId } from '/imports/modules/Quizzes/domain';
import { end, formatRoute, lit, type, url } from '/imports/modules/Routing';

const quiz = lit('quiz');
const quizzes = lit('quizzes');
const solve = lit('solve');
const taskId = type('taskId', TaskId);
const attemptId = type('attemptId', QuizAttemptId);
const questionId = type('questionId', QuestionId);
const summary = lit('summary');

//--------------------------------------------------------------------------------------------------
// React routes
//--------------------------------------------------------------------------------------------------

export const solveQuizRoute = url(quizzes, solve, taskId, attemptId, end);
export const solveQuizLink = formatRoute(solveQuizRoute);

export const solveQuestionRoute = url(quizzes, solve, taskId, attemptId, questionId, end);
export const solveQuestionLink = formatRoute(solveQuestionRoute);

export const solveQuizSummaryRoute = url(quizzes, solve, taskId, attemptId, summary, end);
export const solveQuizSummaryLink = formatRoute(solveQuizSummaryRoute);

//--------------------------------------------------------------------------------------------------
// Express routes
//--------------------------------------------------------------------------------------------------

const solveQuizTaskRoute = url(quiz, solve, taskId, end);
export const solveQuizTaskLink = formatRoute(solveQuizTaskRoute);
